import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
import { ApplicationDebtSource } from "@ploy-lib/types";
class ApplicationDebtResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.termAmount = 0;
        this.refinance = false;
        this.amount = 0;
        this.originalAmount = 0;
        this.comment = "";
        this.lender = "";
        this.loanNumber = "";
        this.loanType = "";
        this.refinanceAccount = "";
        this.refinanceAmount = 0;
        this.willBeFulfilled = false;
        this.source = ApplicationDebtSource.NotSet;
    }
    pk() {
        return `${this.applicationDebtId}`;
    }
    /** Shape to update a list of existing entity (put) */
    static updateList() {
        return this.update().extend({
            schema: [this]
        });
    }
}
// 		Enable optimistic updates?
//
// static getEndpointExtra(): FetchOptions {
// 	return {
// 		...super.getEndpointExtra(),
// 		optimisticUpdate: (params, body) => body
// 	};
// }
ApplicationDebtResource.urlRoot = apiResourceUrl("applications/{applicationNumber}/debts");
export { ApplicationDebtResource };
//# sourceMappingURL=ApplicationDebtResource.js.map